import { useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
import { NotificationContainer, ModalContainer, MainLayout, SidePanelContainer, ProtectedRoute, ProtectedByPermission } from '@/components/layout';
import { useAuthErrorHandler } from '@/hooks/ui';
import { useAppDispatch, useAppSelector } from '@/hooks';
import { checkPendingSSO } from '@/store/slices/authSlice';
import { ROUTE_DEFINITIONS, getAuthenticatedRoutes, getPublicRoutes } from '@/routes';


function App() {
  useAuthErrorHandler();
  const dispatch = useAppDispatch();
  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);

  useEffect(() => {
    if (!isAuthenticated) {
      void dispatch(checkPendingSSO());
    }
  }, [dispatch, isAuthenticated]);

  const authenticatedRoutes = getAuthenticatedRoutes();
  const publicRoutes = getPublicRoutes();

  return (
    <>
      <Routes>
        {/* Rutas públicas (sin layout) */}
        {publicRoutes
          .filter((route) => route.layout === 'none')
          .map((route) => (
            <Route
              key={route.code}
              path={route.path}
              element={<route.component />}
            />
          ))}

        {/* Rutas autenticadas sin layout (ej. vinculación SSO) */}
        {authenticatedRoutes
          .filter((route) => route.layout === 'none')
          .map((route) => (
            <Route
              key={route.code}
              path={route.path}
              element={
                <ProtectedRoute>
                  <route.component />
                </ProtectedRoute>
              }
            />
          ))}

        {/* Rutas con autenticación y layout */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <MainLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<ROUTE_DEFINITIONS.DASHBOARD_ASISTENCIA.component />} />
          
          {authenticatedRoutes
            .filter((route) => route.path !== '/' && route.path !== ROUTE_DEFINITIONS.ACCESO_DENEGADO.path && route.layout !== 'none')
            .map((route) => (
              <Route
                key={route.path}
                path={route.path}
                element={
                  <ProtectedByPermission>
                    <route.component />
                  </ProtectedByPermission>
                }
              />
            ))}

          {/* 403 dentro del layout */}
          <Route
            path={ROUTE_DEFINITIONS.ACCESO_DENEGADO.path}
            element={<ROUTE_DEFINITIONS.ACCESO_DENEGADO.component />}
          />

          {/* 404 dentro del layout */}
          <Route
            path={ROUTE_DEFINITIONS.PAGINA_NO_ENCONTRADA.path}
            element={<ROUTE_DEFINITIONS.PAGINA_NO_ENCONTRADA.component />}
          />
        </Route>
      </Routes>

      {/* Global UI Components */}
      <NotificationContainer />
      <ModalContainer />
      <SidePanelContainer />
    </>
  );
}

export default App;
